import types from './types';

export const setCookieSettingsOpen = (open) => ({
  open,
  type: types.SET_COOKIES_SETTINGS_OPEN,
});

export const setGlobalCookieSettingsIconShown = (shown) => ({
  shown,
  type: types.SET_GLOBAL_COOKIES_SETTINGS_ICON_SHOWN,
});
